import {Injectable} from "@angular/core";
import {CoreErrorHandlerBaseService} from "@core/services/error-handler-base/core-error-handler-base.service";
import {IAlertControllerCreate} from "@shared/interfaces/alert-controller-create.interface";

@Injectable({
  providedIn: 'root'
})
export class TechErrorHandlerMissionService extends CoreErrorHandlerBaseService {
  override _formatAlertFor404(status: number, name: string, message: any): IAlertControllerCreate {
  const missionRoute: string[] = ['tech', 'logged', 'inventory'];

    return {
      header: this._translateService.instant("TECH.INVENTORY.PAGES.MISSIONS.DETAILS.ERRORS.404.HEADER"),
      message: this._translateService.instant("TECH.INVENTORY.PAGES.MISSIONS.DETAILS.ERRORS.404.MESSAGE"),
      buttons: [
        {
          text: this._translateService.instant("TECH.INVENTORY.PAGES.MISSIONS.DETAILS.ERRORS.404.BUTTON"),
          handler: async () => {
            await this._router.navigate(missionRoute);
          }
        }
      ]
    };
  }
}
